/**
 * TvEyebrow — mono UPPERCASE micro-label used above page titles,
 * inside cards, and over module groups.
 *
 *   <TvEyebrow>Marketing &amp; Sales · Today · Fri, May 30</TvEyebrow>
 *
 * Spec: JetBrains Mono · 10px · 500 · uppercase · tracking 0.14em · ink-500.
 */
import React from 'react';
import { tvTokens } from './tokens';

interface TvEyebrowProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export function TvEyebrow({ children, style, ...rest }: TvEyebrowProps) {
  return (
    <div
      {...rest}
      style={{
        fontFamily: tvTokens.fontMono,
        fontSize: 10,
        fontWeight: 500,
        textTransform: 'uppercase',
        letterSpacing: '0.14em',
        color: tvTokens.ink500,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
